import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Typography, CircularProgress, Button, Stack,Tooltip,
  Select,MenuItem,InputLabel,FormControl,RadioGroup,Radio,FormControlLabel,FormLabel
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../store/slices/alertSlice';
import { useOrderDetails,useUpdateOrder } from './vanuser.hooks';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import '../../App.css'; // Assuming you have a global CSS file for styles

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { constants } from '../../constants';
import {convertGMTToLocal} from '../../common';
import { useQueryClient } from '@tanstack/react-query';
function VanOrderDetailsPopup({ orderid, open, onClose }) {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();
  const { data, isLoading,isError,error } = useOrderDetails(orderid, open);

  if(isError)
    {
    dispatch(
      showAlert({
        severity: 'error',
        title: error?.message || 'Failed to load order details.',
      })
    );
    }

  const order = data?.order;
  const [copied, setCopied] = React.useState(false);
  const [updateFlag, setUpdateFlag] = React.useState(false);
  const [paymentmode, setPaymentmode] = React.useState('');
  const [orderId, setOrderId] = React.useState('');
  const [paymentstatus, setPaymentstatus] = React.useState('');
  
  React.useEffect(() => {
    if (order) {
      setPaymentmode(order.paymentmode);
      setPaymentstatus(order.paymentstatus);
      setOrderId(order.order_id);
    }
  }, [order]);
  const handleCopy = async (orderId,orderHashedValue) => {

    const downloadUrl = `${constants.API_BASE}/vanorder/download-bill/${orderId}/${orderHashedValue}`;
  
      try {
        await navigator.clipboard.writeText(downloadUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // reset after 1.5 seconds
        dispatch(
          showAlert({
            severity: 'success',
            title: 'Successfully copied the link.',
          })
        );
      } catch (err) {
        dispatch(
          showAlert({
            severity: 'error',
            title: 'Failed to copy',
          })
        );
      }
    };
    const { mutate: updateOrderFn, isPending } = useUpdateOrder({
      onSuccess: () => {
        dispatch(showAlert({ severity: 'success', title: 'Order updated successfully!' }));
        queryClient.invalidateQueries(['orders']);
      },
      onError: (error) => {
        dispatch(
          showAlert({
            severity: 'error',
            title:
              error?.response?.data?.message ||
              error.message ||
              'Failed to update order.',
          })
        );
      }
    });
const updateOrder=()=>{
  updateOrderFn({
    orderId: orderId,
    paymentmode,
    paymentstatus
  });
}
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Order #{orderid} Details</DialogTitle>

      <DialogContent dividers>
        {isLoading ? (
          <CircularProgress />
        ) : !order ? (
          <Typography>No order data found.</Typography>
        ) : (
          <>
            {/* Order Info */}
            <Stack spacing={1} mb={2}>
  {[
    { label: 'Date & Time', value: convertGMTToLocal(order.created_at) },
    { label: 'Customer', value: `${order.customername} (${order.customerphonenumber})` },
    { label: 'Email', value: order.customeremail || 'N/A' },
    { label: 'Subtotal', value: `€ ${order.orderprice}` },
    { label: 'Coupon Savings', value: order.coupon_discount_amount && order.coupon_code
    ? `€ ${order.coupon_discount_amount} [${order.coupon_code}]`
    : 'N/A' },
    { label: 'Discount', value: `€ ${order.discountamount}` },
    {
      label: 'Net Payable',
      value: `€ ${(
        order.orderprice 
        - (order.discountamount || 0) 
        - ((order.coupon_discount_amount && order.coupon_discount_amount > 0) 
            ? order.coupon_discount_amount 
            : 0)
      ).toFixed(2)}`
    }
  ].map((item, index) => (
    <Stack key={index} direction="row" spacing={2}>
      <Typography sx={{ fontWeight: 'bold', minWidth: 140 }}>
        {item.label}:
      </Typography>
      <Typography>{item.value}</Typography>
 </Stack>
  ))}
   <Stack  direction="row" spacing={2}>
      <Typography sx={{ fontWeight: 'bold', minWidth: 140 }}>
        {'Payment'}:
      </Typography>

      <FormControl  variant="outlined" size="small"  sx={{ minWidth: 150 }}>
          <InputLabel id="paymentmode-label">Payment Mode</InputLabel>
        <Select
      labelId="paymentmode-label"
      id="paymentmode"
      value={paymentmode || ''}
    size='small'
      onChange={(e) =>
        {
          setPaymentmode(e.target.value);
          setUpdateFlag(true);
        }
     
      }
      label="Payment Mode" // Important for proper floating label
    >
      <MenuItem value={constants.PAYMENT_MODE.CASH}>Cash</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.CARD}>Card</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.BANKTRANSFER}>Bank Transfer</MenuItem>
      <MenuItem value={constants.PAYMENT_MODE.PAYPAL}>Paypal</MenuItem>
    </Select>
    </FormControl>
    <FormControl  variant="outlined" size="small"   sx={{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2, // space between label and radios
    minWidth: 150
  }}>
      <FormLabel id='paymentstatus-label'>Status : </FormLabel>
      <RadioGroup
        row
        name="paymentstatus"
        labelId="paymentstatus-label"
        value={paymentstatus}
        onChange={(e) =>
    {
      setPaymentstatus(e.target.value);
      setUpdateFlag(true);
    }
        }
      >
        <FormControlLabel value={constants.PAYMENT_STATUS.PENDING} control={<Radio />} label="Pending" />
        <FormControlLabel value={constants.PAYMENT_STATUS.PAID} control={<Radio />} label="Paid" />
      </RadioGroup>
    </FormControl>
    {
      updateFlag &&
      <Button onClick={updateOrder} variant='contained'>Update</Button>
    }



</Stack>


</Stack>
             <Table className="van-orders-table">
        <Thead>
          <Tr>
            <Th>Product Code</Th>
            <Th>Product Name</Th>
            <Th>Box number</Th>
            <Th>Barcode</Th>
            <Th>Unit Price</Th>
            <Th>Quantity</Th>
            <Th>Line Item Price</Th>
          </Tr>
        </Thead>
        <Tbody>
         {order.order_details?.map((item, idx) => (
            <Tr key={idx}>
              <Td>{item.productcode}</Td>
              <Td>{item.name}</Td>
              <Td>{item.boxnumber}</Td>
              <Td>{item.barcode}</Td>
              <Td>€ {item.unitprice}</Td>
              <Td>{item.quantity}</Td>
              <Td>€ {item.lineitemprice}</Td>
            </Tr>
          ))}
        </Tbody>
            </Table>
          </>
        )}
      </DialogContent>

      <DialogActions>
     { (order)?
        <Tooltip title={copied ? 'Copied!' : 'Copy invoice link'}>
        <button
          onClick={() => handleCopy(order.order_id, order.hashedvalue)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
          aria-label="Copy download link"
>
          <ContentCopyIcon />
        </button>
      </Tooltip>

:null}
        <Button onClick={onClose} variant='contained'>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default VanOrderDetailsPopup;
